var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHltVCms02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_2347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3593 24.9045C37.4419 25.2731 38.4307 25.85 39.268 26.5869L42.4869 25.4553L44.6521 29.2057L42.0683 31.4236C42.1765 31.9674 42.2271 32.5296 42.2271 33.1046C42.2271 33.6796 42.1765 34.2417 42.0683 34.7855L44.6521 37.0032L42.4869 40.7536L39.268 39.622C38.4307 40.3589 37.4419 40.9356 36.3593 41.3044L35.7314 44.6523H31.4009L30.773 41.3044C29.6975 40.9357 28.7088 40.3589 27.8643 39.622L24.6525 40.7536L22.4873 37.0032L25.0711 34.7853C24.9629 34.2415 24.9051 33.6795 24.9051 33.1044C24.9051 32.5293 24.9628 31.9672 25.0711 31.4234L22.4873 29.2055L24.6525 25.4552L27.8643 26.5867C28.7087 25.8498 29.6975 25.2731 30.773 24.9043L31.4009 21.5564H35.7314L36.3593 24.9045Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5661 35.9914C35.1606 35.9914 36.4531 34.6989 36.4531 33.1045C36.4531 31.5101 35.1606 30.2175 33.5661 30.2175C31.9717 30.2175 30.6792 31.5101 30.6792 33.1045C30.6792 34.6989 31.9717 35.9914 33.5661 35.9914Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6694 21.5564V10.0085L28.7739 15.7825L18.6694 21.5564Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.664 30.2174H1.34766V1.34766H44.6523V30.2174H43.4759L44.6523 29.2056L42.4871 25.4553L39.2682 26.5868C38.4309 25.8499 37.4421 25.2731 36.3595 24.9044L35.7316 21.5565H31.4011L30.7732 24.9044C29.6978 25.2731 28.709 25.8499 27.8645 26.5868L24.6528 25.4553L22.4875 29.2056L23.664 30.2174Z",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_2347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHltVCms02);
export default __webpack_public_path__ + "static/media/HLT-vCMS02.9cff2faabdc5fb50b4bc9ad91a5976c0.svg";
export { ForwardRef as ReactComponent };